/**
 * Format currency text using clientAPI
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

import { BitmapFont, BitmapText, Text } from 'pixi.js'

/**
 * Format currency text using clientAPI
 * @param value currency value to display
 * @param removeSymbol - whether or not to remove the currency symbol (bitmap text might be missing a symbol)
 * @returns Currency formatted text
 */
export function formatCurrency(value: number, removeSymbol = true): string {
    const currency = window.clientAPI.currency

    // remove currency symbols if any of the currency symbols are missing
    return currency.format(value, 'bespoke', currency.displaySign, !removeSymbol ? 'start' : undefined) as string
}

/**
 * Returns whether or the text supports the currency symbol
 * @param text - text asset to check the text of
 * @param sign - currency sign that will be displayed
 * @returns whether or not the provided currency supports all characters
 */
export function hasAllCharacters(text: BitmapText | Text, sign: string): boolean {
    if (text instanceof BitmapText) {
        const bitmapFont = BitmapFont.available[text.fontName]
        for (const char of sign) {
            if (!bitmapFont.chars[char.charCodeAt(0)]) {
                return false
            }
        }
    }
    return true
}

/**
 * Format value to a currency amount
 * @param text text to check whether or not its supported
 * @param value number value to display on the text
 * @returns currency formatted string, removing unsupported symbols
 */
export function formatPixiText(value: number, text: BitmapText | Text): string {
    const currency = window.clientAPI.currency
    const hasAllChars = hasAllCharacters(text, currency.displaySign)
    return formatCurrency(value, hasAllChars)
}
